import React from "react";
import "../HomeSolution.css";
import { Link } from "react-router-dom";

import {
  FiArrowRight,
  FiCreditCard,
  FiShield,
  FiCheckCircle,
  FiSearch,
  FiUsers,
  FiBriefcase,
} from "react-icons/fi";

const solutions = [
  {
    icon: <FiBriefcase />,
    title: "FinTech Consulting",
    description:
      "Strategic consulting services that help financial institutions and fintech businesses accelerate digital transformation, optimize operations, and adopt innovative technologies.",
    link: "/fintech-consulting",
  },
  {
    icon: <FiCreditCard />,
    title: "Payment Solutions",
    description:
      "Secure and scalable payment solutions enabling seamless digital transactions, payment gateway integration, reconciliation, and transaction processing.",
    link: "/payment-solutions",
  },
  {
    icon: <FiShield />,
    title: "Compliance Support",
    description:
      "Comprehensive compliance assistance designed to help organizations meet regulatory requirements while reducing operational and financial risk.",
    link: "/compliance-support",
  },
  {
    icon: <FiCheckCircle />,
    title: "AML Managed Services",
    description:
      "End-to-end Anti-Money Laundering services including transaction monitoring, risk assessment, case management, and compliance reporting.",
    link: "/aml-managed",
  },
  {
    icon: <FiSearch />,
    title: "Third Party Risk",
    description:
      "Vendor due diligence and third-party risk management services to strengthen security, governance, and operational resilience.",
    link: "/third-party-risk-management",
  },
  {
    icon: <FiUsers />,
    title: "KYC Verification",
    description:
      "Digital Know Your Customer (KYC) verification solutions for secure customer onboarding, identity validation, and fraud prevention.",
    link: "/kyc-verification",
  },
];

const HomeSolution = () => {
  return (
    <section className="home-solution">

      <div className="container">

        {/*=========================
              SECTION HEADER
        =========================*/}

        <div className="solution-heading">

          <span className="solution-tag">
            OUR SOLUTIONS
          </span>

          <h2>
            Auxiliary FinTech Solutions
            <span> Built for Modern Businesses</span>
          </h2>

          <p>
            We deliver secure, scalable, and compliance-driven fintech
            solutions that empower banks, NBFCs, payment providers,
            fintech startups, and financial institutions to innovate,
            automate operations, and accelerate business growth.
          </p>

        </div>

        {/*=========================
              SOLUTIONS GRID
        =========================*/}

        <div className="solution-grid">

          {solutions.map((item, index) => (

            <div
              className="solution-card"
              key={index}
            >

              <div className="solution-icon">
                {item.icon}
              </div>

              <h3>{item.title}</h3>

              <p>{item.description}</p>

              <a
                href={item.link}
                className="solution-btn"
              >
                Read More
                <FiArrowRight />
              </a>

            </div>

          ))}

        </div>

      </div>

    </section>
  );
};

export default HomeSolution;